import { Component, OnInit, ChangeDetectorRef, OnDestroy, ChangeDetectionStrategy, AfterViewInit } from "@angular/core";
import { LocationDetailViewModel, OrdertypeViewModel } from "../../shared/models";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { CoreLogService } from "../../services/log.service";
import { ActivatedRoute, Router } from "@angular/router";
import { SnackBarService } from "../../services/snackBar.service";
import { Subscription, Observable } from "rxjs";
import { ContentType, PhoneCallError, VoucherServiceType, WebShopMode } from "../../shared/contentTypes";
import { LocationDetailService } from "./locationDetail.service";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { ReservationSettingService } from "../../services/reservationSetting.service";
import { RouterHelperService } from "../../services/routerHelper.service";
import { CoreCOMService } from "../../services/com.service";
import { WebShopService } from "../../services/webShop.service";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { LocationService } from "../location/location.service";
import { Location } from "@angular/common";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { LocationImpressumDialogComponent } from "../../modalDialogs";
import { DomSanitizer } from "@angular/platform-browser";
import Utils from "../../shared/utils";
import { RemoteGroupOrderService } from "../../services/RemoteGroupOrder.service";
import { DeviceLocationService } from "../../services/deviceLocation.service";

@Component({
  selector: "locationDetail",
  templateUrl: "./locationDetail.component.html",
  styleUrls: ["./locationDetail.component.scss"],
  providers: [LocationDetailService, OverlaySpinnerService, ReservationSettingService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocationDetailComponent implements OnInit, OnDestroy, AfterViewInit {

  public hasData: boolean = true; // check if there is data for this page;
  private locationId: number | string;
  public locationDetailViewModel: LocationDetailViewModel = new LocationDetailViewModel();
  public fullDaysPanelOpened: boolean;
  public contentType = ContentType;
  public matGroupSelectedIndex: number;
  public WebShopMode = WebShopMode;
  public isSmallView: boolean = false;
  public currentLocation: number;
  private menuSettingLocationIds: number[];
  private enabledVoucherCharge: boolean = false;
  private _langSubscriber: Subscription;
  private _locationChangesSubscriber: Subscription;
  public ordertypes$: Observable<OrdertypeViewModel[]>;

  constructor(private _locationDetailService: LocationDetailService
    , private _locationService: LocationService
    , private _internationalisationService: InternationalisationService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _activatedRoute: ActivatedRoute
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _snackBarService: SnackBarService
    , private _routerHelperService: RouterHelperService
    , private _coreComService: CoreCOMService
    , private _router: Router
    , private _domSanitizer: DomSanitizer
    , private _location: Location
    , private _webShopService: WebShopService
    , private _remoteGroupOrderService: RemoteGroupOrderService
    , _mainnavService: MainnavService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _deviceLocationService: DeviceLocationService) {
    this.isSmallView = _mainnavService.viewType === ViewType.Small;
  }

  ngAfterViewInit(): void {
    const me = this;
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("LocationDetailComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.matGroupSelectedIndex = 0;
    me.fullDaysPanelOpened = false;
    me._webShopService.getWebshopSettingsDataModel()
      .then((webshopSettingsDataModel) => {
        me.enabledVoucherCharge = webshopSettingsDataModel.is_vouchercharge_enabled;
      })
      .catch(e => {
        me._coreLogService.error("LocationDetailComponent.Init", "_webShopService.getWebshopSettingsDataModel", e);
        me._snackBarService.ShowErrorMessageFailed(50);
      });

    me._activatedRoute.paramMap.subscribe(params => {
      me.locationId = params.get("id");
    });
    me.menuSettingLocationIds = me._activatedRoute.snapshot.data["menuSettingData"].menuSettingLocationIds;

    me._langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });

    me._locationChangesSubscriber = me._locationDetailService.ObserveChanges.subscribe((change) => {
      me.reloadDataAndRender();
    });

    me.reloadDataAndRender();
  }

  /**
   * Load location data
   */
  private reloadDataAndRender(): void {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._locationDetailService.GetLocationDetailViewModel(me.locationId)
      .then(location => {
        if (location) {
          me.locationDetailViewModel = location;
          this.ordertypes$ = this._locationDetailService.getSupportServices$(location.hyp_cus_nr);
          me.hasData = true;
          me.PushChanges();
          if (!me._coreComService.environment.client.isMobile) {
            me.setCoordinate()
          }
        } else {
          me.hasData = false;
          me.PushChanges();
        }
        setTimeout(() => {
          me.PushChanges();
        }, 200);
        // me.initialAnimation();
        me._overlaySpinnerService.HideLayoutSpinner();
      })
      .catch(e => {
        me._coreLogService.error("LocationDetailComponent.reloadDataAndRender", "GetLocationViewModel", e);
        me._overlaySpinnerService.HideLayoutSpinner();
        me._snackBarService.ShowErrorMessageFailed(51);
      });
  }


  private async setCoordinate() {
    const me = this;
    try {
      const coordinates = await me._deviceLocationService.getCurrentPosition();
      if (coordinates) {
        if (me.locationDetailViewModel.latitude > 0 && me.locationDetailViewModel.longitude > 0) {
          me.locationDetailViewModel.distance = +(Utils.getDistanceBetweenPoints(coordinates.latitude, coordinates.longitude, me.locationDetailViewModel.latitude, me.locationDetailViewModel.longitude).toFixed(1));
        } else {
          me.locationDetailViewModel.distance = -1;// no distance will be shown
        }
      }
    } catch (error) {
      me._coreLogService.error("LocationDetailComponent.setCoordinate", "_deviceLocationService.getCurrentPosition", error);
    }
    me.PushChanges();
  }

  /**
 * Handle changeTabEvent
 * @param event event Instance
 */
  public tabSelectedIndexChange(index: number): void {
    const me = this;
    me.matGroupSelectedIndex = index;
    me.PushChanges();
  }

  public navigateBack(): void {
    this._routerHelperService.navigateBackSimple();
  }

  public fullDaysPanelToggle(): void {
    const me = this;
    me.fullDaysPanelOpened = !me.fullDaysPanelOpened;
    me.PushChanges();
  }

  /**
* Calls when each news favorite icon, clicked by user
* @param news The newsviewmodel that it's favorite icon has been clicked
*/
  public onPhoneCallAction(locationDetail: LocationDetailViewModel) {
    const me = this;
    me._coreComService.environment.phoneCall.dial(
      locationDetail.phone_no,
      function (error) {
        if (error === PhoneCallError.empty) {
          me._coreLogService.error("LocationDetailComponent", "LocationMap.onPhoneCallAction", error);
        } else {
          me._coreLogService.error("LocationDetailComponent", "LocationMap.onPhoneCallAction", error);
        }
      },
      function (success) {
        me._coreLogService.info("LocationDetailComponent", "LocationMap.onPhoneCallAction");
      }
    );
  }

  public openEMailApp(locationDetail: LocationDetailViewModel): void {
    location.href = "mailto:" + locationDetail.mail;
  }

  public routeToPath(path: string) {
    this._router.navigate(["/" + path]);
  }

  /**check service to route to target page
   * for delivery it must route to menulocation
   * for others route to menugroup
   */
  public checkService(mode: WebShopMode) {
    const me = this;
    const serviceID = me._webShopService.getServiceMode();
    const isRemoteOrder = serviceID === WebShopMode.DeliveryGroup || serviceID === WebShopMode.PickupGroup
    if (isRemoteOrder && me._remoteGroupOrderService.groupId !== 0) {
      me._webShopService.openWarningLeaveGroup(me._webShopService.locationID, mode)
    } else {
      me._webShopService.openWarningResetBasketDialogIfNeed(me._webShopService.locationID, mode, async (agree) => {
        if (agree) {
          await me.setService(mode);
        } /* else do nothing */
      });
    }

  }

  /**initilize service; use seperate initialization for voucher service */
  private async setService(servicemode: WebShopMode) {
    const me = this;
    if (servicemode === WebShopMode.Webvoucher) {
      me.intializeVoucherService();
    } else {
      await me.initializeService(servicemode);
    }
  }

  /**initialize service for voucher */
  private async intializeVoucherService(): Promise<void> {
    const me = this;
    try {
      let serviceMode: WebShopMode;
      const mode = WebShopMode.Webvoucher;
      if (me.enabledVoucherCharge) {
        serviceMode = await me._webShopService.setServiceMode(mode, true, me._webShopService.voucherServiceType);
        me._router.navigate(["/vouchercredit"]);
      } else {
        await me._webShopService.setServiceMode(mode, true, VoucherServiceType.Order);
        await me._webShopService.setServiceLocationByID(+me.locationId);
        me._webShopService.tryAndRouteToSingleVariableWebvoucher();
      }
    } catch (error) {
      me._coreLogService.error("LocationDetailComponent.intializeVoucherService", "try catch", error);
    }
  }

  /** Initialize service mode and navigate */
  private async initializeService(serviceMode: WebShopMode) {
    const me = this;
    await me._webShopService.setServiceMode(serviceMode);

    if (serviceMode === WebShopMode.Delivery) {
      me._router.navigate(["/orderAddressQuery"]);
      return;
    }
    if (serviceMode === WebShopMode.OrderToTable) {
      me._router.navigate(["/qrcodescanner"]);
      return;
    }
    if (serviceMode === WebShopMode.Ticket || serviceMode === WebShopMode.Retail || serviceMode === WebShopMode.Viewing) {
      await me.setServiceDataAndHandleNavigation(serviceMode);
      return;
    }
    if (serviceMode === WebShopMode.TakeAway) {
      me._webShopService
      await me.initializeServiceTimeSelectionOptions(serviceMode);
      return;
    }

  }

  private async loadLocationViewModel(serviceMode: WebShopMode) {
    const me = this;
    const locationIdNumber = parseInt(me.locationId as string, 10);
    const webShopLocation = await me._locationService.GetWebshopLocationInfoViewModel(serviceMode, locationIdNumber);
    return webShopLocation;
  }

  private async setServiceDataAndHandleNavigation(serviceMode: WebShopMode) {
    const me = this;
    const webShopLocation = await me.loadLocationViewModel(serviceMode);
    me._webShopService.setServiceLocationInfo(webShopLocation, "").then(() => {
      me._router.navigate(["/menugroup"]);
    });
  }

  private async initializeServiceTimeSelectionOptions(serviceMode: WebShopMode) {
    const me = this;
    const location = await me.loadLocationViewModel(serviceMode);
    await me._webShopService.initializeAndProcessServiceTime({
      serviceMode: serviceMode,
      location: location,
    });
  }

  public openMapMarker() {
    const me = this;
    const locModel = me.locationDetailViewModel;
    // Perform a map search using street, zip and location if at least the street is available
    // otherwise fallback -> coordinates -> nothing
    if (locModel.street.length > 0) {
      let SearchString = locModel.street;
      if (locModel.zip.length > 0 || locModel.location.length > 0) {
        SearchString += ", " + locModel.zip + " " + locModel.location;
      }
      SearchString = encodeURIComponent(SearchString);
      window.open("https://www.google.com/maps/search/?api=1&query=" + SearchString, "_system");
    } else if (locModel.latitude !== 0 || locModel.longitude !== 0) {
      window.open("http://maps.google.com/maps?q=" + me.locationDetailViewModel.latitude + "," + me.locationDetailViewModel.longitude + "(" + me.locationDetailViewModel.label + ")", "_system");
    }
  }

  public swipeRightHandler() {
    const me = this;
    if (me.matGroupSelectedIndex > 0) {
      --me.matGroupSelectedIndex;
      me.PushChanges();
    } else {
      this.SwiperNavigateBack();
    }
  }

  public swipeLeftHandler() {
    const me = this;
    if (me.matGroupSelectedIndex < 1) {
      ++me.matGroupSelectedIndex;
      me.PushChanges();
    }
  }

  /**When small view is true, navigation back by swiping from left to right.*/
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }
  public get impressumModelData() {
    const me = this;
    return me.locationDetailViewModel;
  }

  public openLocationImpressumDialog() {
    const me = this;
    if (me.impressumModelData !== null && me.impressumModelData !== undefined) {
      me._bottomSheetHelperService.open(
        LocationImpressumDialogComponent,
        {
          data: {
            impressumHtml: me._domSanitizer.bypassSecurityTrustHtml(me.impressumModelData.impressumHtml),
          },
          panelClass: "mat-bottom-sheet-container--full-height",
        }
      );
    } else {
      // Handle null or undefined case here
    }
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
    if (me._locationChangesSubscriber) {
      me._locationChangesSubscriber.unsubscribe();
    }
  }
}
